declare global {
  interface Window {
    myAntsTag?: (...args: any[]) => void;
  }
}

export function pageview(path: string) {
  if (!localStorage.getItem('userId')) {
    window.myAntsTag?.('EVENT', 'PAGE_VIEW', {
      page: window.location.origin + path
    });
  }
}

export function clearLocalStorage() {
  localStorage.clear();
}
